.story { --mineral-progress: 0; position: relative; height: 480svh; color: #f3f6f7; background: #172229; isolation: isolate; }
.stage { position: sticky; top: var(--sm-header-height, 76px); height: calc(100svh - var(--sm-header-height, 76px)); min-height: 560px; overflow: hidden; background: #172229; }
.canvas, .poster, .shade { position: absolute; inset: 0; width: 100%; height: 100%; }
.canvas { display: block; opacity: 0; transition: opacity .4s; }
.poster img { display: block; width: 100%; height: 100%; object-fit: cover; }
.story[data-status="ready"] .canvas { opacity: 1; }
.shade { pointer-events: none; background: linear-gradient(90deg, #0c181fee, #0c181fa8 26%, #0c181f00 54%), linear-gradient(0deg, #101a22ee, transparent 24%, transparent 88%, #0c181f6b); }
.top { position: absolute; inset: 1.6rem 4.5% auto; display: flex; align-items: center; justify-content: space-between; gap: 1.5rem; }
.top h1 { margin: 0; font: 500 .95rem/1.4 var(--font-body, sans-serif); letter-spacing: .015em; color: #edf3f4; }
.actions { display: flex; flex-wrap: wrap; gap: 1.5rem; justify-content: flex-end; }
.actions a, .actions button { font: inherit; font-size: .8rem; line-height: 1.4; padding: .4rem 0; color: #e0e8ec; background: transparent; border: 0; border-bottom: 1px solid #a4b8c44a; text-decoration: none; cursor: pointer; }
.editorial { position: absolute; left: 4.5%; top: 20%; width: min(460px, 34%); }
.kicker { display: block; margin-bottom: 1.8rem; font-size: .72rem; letter-spacing: .11em; color: #e3c78e; }
.kicker span { display: block; margin-top: .6rem; font-size: .68rem; color: #b9ccd5; }
.number { display: block; margin-bottom: 1rem; font-size: .82rem; font-variant-numeric: tabular-nums; color: #e4c78c; }
.number i { font-style: normal; margin-left: .4rem; color: #afbec8; }
.copy h2 { margin: 0; font-family: var(--font-display); font-size: clamp(2rem, 3.55vw, 4.15rem); font-weight: 500; line-height: 1.07; letter-spacing: -.045em; color: #f3f6f7; text-wrap: balance; overflow-wrap: break-word; }
.copy p { margin: 1.3rem 0 0; max-width: 370px; font-size: clamp(.9rem, 1.1vw, 1rem); line-height: 1.65; color: #cedae0; }
.product { margin-top: 1.4rem; display: inline-flex; justify-content: space-between; align-items: center; gap: 1.2rem; max-width: 100%; padding: .75rem 1rem; border: 1px solid #9fb3bf80; color: #f4f6f7; text-decoration: none; font-size: .85rem; line-height: 1.5; }
.technical { margin-top: 1.2rem; padding-top: .8rem; border-top: 1px solid #c8af7966; color: #f3f6f7; }
.technicalMobile { display: none; }
.technicalTitle { display: block; font-size: .65rem; line-height: 1.3; letter-spacing: .06em; color: #eed4a4; }
.technicalTitle > span { color: #cbd8df; margin-left: .4rem; }
.technical dl { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: .8rem; margin: .55rem 0 0; }
.technical dt { font-size: .65rem; line-height: 1.3; color: #d5e0e5; overflow-wrap: anywhere; }
.technical dd { margin: .25rem 0 0; font: 500 clamp(1.2rem, 1.9vw, 1.6rem)/1.15 var(--font-body, sans-serif); font-variant-numeric: tabular-nums; white-space: nowrap; color: #fff; }
.technical dd > span { font-size: .65rem; margin-left: .35rem; color: #e1c78f; }
.technical p { margin: .5rem 0 0; font-size: .6rem; line-height: 1.4; color: #d4dfe5; }
.technical a { color: #f2d6a3; text-decoration: underline; text-underline-offset: 2px; }
.technicalContent { animation: technicalReveal .3s ease-out; }
@keyframes technicalReveal { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: none; } }
.sceneLabel { position: absolute; right: 5%; top: 65%; font-size: .7rem; letter-spacing: .1em; color: #e6c889; text-shadow: 0 1px 6px #0a121a; }
.sceneLabel > span { display: inline-block; width: 5px; height: 5px; background: #e6c889; border-radius: 50%; margin-right: .5rem; }
.sceneLabel small { display: block; font-size: .66rem; letter-spacing: 0; margin-top: .45rem; color: #d6e1e5; }
.loading { position: absolute; right: 8%; top: 50%; font-size: .8rem; color: #d4e0e6; }
.bottom { position: absolute; inset: auto 4.5% 5.3rem; display: flex; align-items: flex-end; justify-content: space-between; gap: 2rem; }
.scroll { display: flex; gap: 1.2rem; align-items: center; font-size: .78rem; line-height: 1.5; color: #ccd9df; max-width: 250px; }
.scroll > span { font-size: 1.35rem; }
.chapters { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: .5rem; max-width: 60%; }
.chapters button { font: inherit; font-size: .76rem; line-height: 1.3; padding: .65rem .7rem .1rem; background: transparent; border: 0; border-top: 1px solid #a4b6c45c; color: #beced8; cursor: pointer; text-align: left; overflow-wrap: anywhere; }
.chapters button > span { display: block; font-size: .66rem; margin-bottom: .5rem; }
.chapters button[aria-current="step"] { border-color: #e4c78c; color: #f0d6a5; }
.chapters button:focus-visible, .actions button:focus-visible, .actions a:focus-visible, .product:focus-visible { outline: 2px solid #e4c78c; outline-offset: 4px; }
.progress { position: absolute; inset: auto 0 0; height: 2px; background: #bdcbd420; }
.progress span { display: block; width: 100%; height: 100%; transform: scaleX(var(--mineral-progress)); transform-origin: left; background: #e4c78c; }
.story[data-static="true"] { height: auto; }
.story[data-static="true"] .stage { position: relative; top: 0; }
/* Local authoring view for clean fallback exports, without UI baked into pixels. */
.story[data-authoring="true"] :is(.poster, .shade, .top, .editorial, .technical, .sceneLabel, .loading, .bottom, .progress) { visibility: hidden; }
@media (min-width: 1024px) {
  .story[data-chapter="3"] .scroll { visibility: hidden; }
}
@media (min-width: 1024px) and (max-height: 720px) {
  .stage { min-height: 460px; }
  .editorial { top: 15%; width: min(430px, 33%); }
  .kicker { margin-bottom: 1rem; }
  .copy h2 { font-size: clamp(1.8rem, 3vw, 3rem); }
  .copy p { font-size: .85rem; margin-top: .8rem; line-height: 1.5; }
  .product { margin-top: .8rem; }
  .technical { margin-top: .75rem; padding-top: .55rem; }
  .technical dd { font-size: 1.2rem; }
}
@media (max-width: 1023px) {
  .story { height: 420svh; }
  .stage { min-height: 580px; }
  .canvas, .poster { top: 23%; height: 57%; }
  .shade { background: linear-gradient(0deg, #172229 0%, #172229 17%, #17222900 35%, #17222900 52%, #172229e6 77%, #172229 93%); }
  .top { inset: .9rem 5% auto; gap: .5rem; align-items: flex-start; }
  .top h1 { font-size: .78rem; max-width: 43%; }
  .actions { gap: .6rem; max-width: 54%; }
  .actions a, .actions button { font-size: .68rem; }
  .editorial { left: 5%; top: 10%; width: 90%; }
  .kicker { font-size: .6rem; margin-bottom: .65rem; }
  .kicker span { display: inline; margin-left: .5rem; font-size: .6rem; }
  .number { position: absolute; right: 0; top: 0; font-size: .65rem; }
  .copy h2 { font-size: clamp(1.7rem, 6.5vw, 2.4rem); max-width: 95%; line-height: 1.06; }
  .copy p { font-size: .8rem; line-height: 1.45; margin-top: .65rem; max-width: 100%; }
  .product { margin-top: .6rem; padding: .5rem .7rem; font-size: .75rem; }
  .technicalDesktop { display: none; }
  .technicalMobile { display: block; position: absolute; left: 5%; right: 5%; bottom: 11rem; margin: 0; padding: .65rem .75rem; background: #0e1a22eb; border: 1px solid #c8af7966; }
  .technical dd { font-size: 1.1rem; }
  .technical dd > span { font-size: .58rem; margin-left: .2rem; }
  .technical dt { font-size: .6rem; }
  .technicalTitle { font-size: .6rem; }
  .technical p { font-size: .56rem; }
  .sceneLabel { display: none; right: 5%; top: 67%; font-size: .6rem; }
  .sceneLabel small { font-size: .56rem; }
  .bottom { inset: auto 5% 5rem; display: block; }
  .scroll { max-width: none; margin-bottom: .6rem; font-size: .65rem; gap: .8rem; }
  .chapters { width: 100%; max-width: none; gap: .3rem; }
  .chapters button { font-size: .65rem; padding: .5rem .15rem 0; }
  .chapters button > span { margin-bottom: .3rem; font-size: .6rem; }
  .loading { top: 51%; right: 15%; }
}
@media (max-height: 600px) and (max-width: 759px) {
  .story { height: auto; }
  .stage { position: relative; top: 0; height: 640px; }
}
@media (min-width: 760px) and (max-width: 1023px) {
  .copy h2 { font-size: 2.7rem; }
  .copy p { font-size: 1rem; max-width: 620px; }
  .top h1 { font-size: .95rem; }
  .actions a, .actions button { font-size: .8rem; }
  .chapters button { font-size: .8rem; }
}
@media (prefers-reduced-motion: reduce) { .canvas { transition: none; } .technicalContent { animation: none; } }
